import { toast } from "react-toastify";

const Toaster = {
  success: (message, options = {}) => {
    toast.dismiss();       
    toast.success(message, options);
  },
  error: (message, options = {}) => {
    toast.dismiss();      
    toast.error(message, options);
  },
  info: (message, options = {}) => {
    toast.dismiss();
    toast.info(message, options);
  }
};

export default Toaster;
